/* ═══════════════════════════════════════════════════
   INTERNA PERFUMES — THEME.JS
═══════════════════════════════════════════════════ */
(function () {
  'use strict';

  // ── Nav scroll effect ──
  const nav = document.getElementById('nav');
  const announce = document.querySelector('.announce');

  function updateNav() {
    if (!nav) return;
    const scrolled = window.scrollY > 60;
    nav.classList.toggle('scrolled', scrolled);
    // offset for announcement bar
    if (announce && !scrolled) {
      nav.style.top = announce.offsetHeight + 'px';
    } else {
      nav.style.top = '0';
    }
  }
  window.addEventListener('scroll', updateNav, { passive: true });
  updateNav();

  // ── Mobile Menu ──
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobileOverlay');
  const mobileClose = document.getElementById('mobileClose');

  function openMobileMenu() {
    mobileMenu.classList.add('open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    mobileOverlay.classList.add('open');
    mobileOverlay.setAttribute('aria-hidden', 'false');
    hamburger.classList.add('open');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mobileMenu.classList.remove('open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileOverlay.classList.remove('open');
    mobileOverlay.setAttribute('aria-hidden', 'true');
    hamburger.classList.remove('open');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // Close mobile menu on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileMenu();
      closeSearch();
    }
  });

  // ── Search Toggle ──
  const searchToggle = document.getElementById('searchToggle');
  const searchBar = document.getElementById('searchBar');

  function openSearch() {
    if (!searchBar) return;
    searchBar.classList.add('open');
    searchBar.setAttribute('aria-hidden', 'false');
    const input = searchBar.querySelector('input');
    if (input) setTimeout(() => input.focus(), 100);
  }

  window.closeSearch = function () {
    if (!searchBar) return;
    searchBar.classList.remove('open');
    searchBar.setAttribute('aria-hidden', 'true');
  };

  if (searchToggle) searchToggle.addEventListener('click', openSearch);

  // ── Accordion ──
  document.querySelectorAll('.accordion-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const isOpen = this.classList.contains('open');

      // Close all
      document.querySelectorAll('.accordion-btn').forEach(function (b) {
        b.classList.remove('open');
        if (b.nextElementSibling) {
          b.nextElementSibling.classList.remove('open');
        }
      });

      if (!isOpen) {
        this.classList.add('open');
        if (content) content.classList.add('open');
      }
    });
  });

  // ── Size Selector (Product page) ──
  window.selectSize = function (btn, price) {
    document.querySelectorAll('.size-opt').forEach(function (b) {
      b.classList.remove('active');
    });
    btn.classList.add('active');
    const priceEl = document.getElementById('price');
    if (priceEl) priceEl.textContent = price;
  };

  // ── Quantity Controls (Cart page) ──
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = this.closest('.qty-control').querySelector('.qty-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'minus') val = Math.max(1, val - 1);
      if (this.dataset.action === 'plus') val = val + 1;
      input.value = val;
    });
  });

  // ── Wishlist toggle ──
  document.querySelectorAll('.wishlist').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const filled = this.textContent === '♥';
      this.textContent = filled ? '♡' : '♥';
      this.style.color = filled ? '' : '#C9A96E';
    });
  });

  // ── Newsletter (homepage inline) ──
  const newsletterBtn = document.querySelector('.newsletter-btn');
  if (newsletterBtn) {
    newsletterBtn.addEventListener('click', function () {
      const input = document.querySelector('.newsletter-input');
      if (input && input.value.includes('@')) {
        input.value = '';
        input.placeholder = '✦  Welcome to Interna.';
      }
    });
  }

  // ── Active nav link ──
  const currentPath = window.location.pathname;
  document.querySelectorAll('.nav-links a, .mobile-nav-links a').forEach(function (link) {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });

  // ── Smooth reveal on scroll (CSS class approach — elements visible by default) ──
  if ('IntersectionObserver' in window) {
    var revealItems = document.querySelectorAll('.pillar, .product-card, .ingredient-item, .story-stat, .story-value');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

    revealItems.forEach(function (item) {
      item.classList.add('js-reveal');
      observer.observe(item);
    });

    // Failsafe: reveal everything after 1.5s no matter what
    setTimeout(function () {
      revealItems.forEach(function (item) { item.classList.add('revealed'); });
    }, 1500);
  }

})();
